<!-- <dashboardnav>
</dashboardnav> -->
  <!-- <pre>pre {{ (isLoadingLessorStakeholder$ | async) | json }}</pre> -->

  <div class="box green_box"></div>
  <div class="box pink_box"></div>
    <main class="main_acquisition" [@fadeInAnimation]>
    <cradua-search
      [subSubGroups]="subSubGroup$ | async"
      [subGroups]="subGroup$ | async"
      [groups]="group$ | async"
      [task]="task"
      [activities]="activities"
      [landTitle]="landTitle$ | async"
      [view]="view"
      (searchEmit)="onSearch($event)"
      (emitTask)="onTask($event)"

      >
      </cradua-search>
  <div [ngSwitch]="task">
    <ng-template ngSwitchCase="list">
      <cradua-acquisition-list
        [landTitles]="landTitle$ | async"
        [subSubGroups]="subSubGroup$ | async"
        [subGroups]="subGroup$ | async"
        [groups]="group$ | async"
        [measures]="measure$ | async"
        [currencies]="currency$ | async"
        [activities]="activities"
        [acquisitionTypes]="acquisitionType$ | async"
        (dispatchView)="onEmitView($event)"
        *ngIf="
          !((isLoadingLandTitle$ | async) === true && !loadingLandTitle) &&
          !(isLoadingAcquisitionType$ | async) &&
          !(isLoadingCurrency$ | async) &&
          !(isLoadingMeasure$ | async) &&
          !(isLoadingSubSubGroup$ | async) &&
          !(isLoadingGroup$ | async) &&
          !(isLoadingSubGroup$ | async) &&
          !(isLoadingLandParcel$ | async)
        "
      >
    </cradua-acquisition-list>
      <cradua-list-spinner
        *ngIf="
        ((isLoadingLandTitle$ | async))||
          (isLoadingAcquisitionType$ | async) ||
          (isLoadingCurrency$ | async) ||
          (isLoadingMeasure$ | async) ||
          (isLoadingSubSubGroup$ | async) ||
          (isLoadingGroup$ | async) ||
          (isLoadingSubGroup$ | async) ||
          (isLoadingLandParcel$ | async)
        "
      >
      </cradua-list-spinner>

    </ng-template>


    <ng-template ngSwitchCase="create">
      <ng-container *ngIf="(selectedLandTitle$ | async) as selectedLandTitle">
      <cradua-create-acquisition
      [loggedInUser]="loggedInUser"
      [landTitles]="selectedLandTitle"
      [subSubGroups]="subSubGroup$ | async"
      [subGroups]="subGroup$ | async"
      [groups]="group$ | async"
      [activities]="activities"
      [measures]="measure$ | async"
      [currencies]="currency$ | async"
      [acquisitionTypes]="acquisitionType$ | async"
      [accountableFunctions]="accountableFunction$ | async"
      [categories]="category$ | async"
      [landUseStatus]="landUseStatus$ | async"
      [divestment]="divestment$ | async"
      [rightHeld]="rightHeld$ | async"
      [purposes]="purpose$ | async"
      [terrains]="terrain$ | async"
      [bankingStatus]="bankingStatus$ | async"
      [measuringFactors]="measuringFactor$ | async"
      [landParcels]="landParcel$ | async"
      [appConfigs]="appConfig$ | async"
      [geoDatums]="geoDatum$ | async"
      [divisions]="division$ | async"
      [cofOStatus]="cofOStatus$ | async"
      [communities]="community$ | async"
      [fetchDocuments]="fetchDocument$ | async"
      [lessorInfos]="lessorInfo$ | async"
      [lessorAreaMakers]="lessorAreaMaker$ | async"
      [lessorRepresentatives]="lessorRepresentative$ | async"
      [lessorStakeholders]="lessorStakeholder$ | async"
      [individualAcreages]="individualAcreages$ | async"
      [assetLocations]="assetLocation$ | async"
      [lgas]="lga$ | async"
      [states]="state$ | async"
      [quantums]="quantums$ | async"
      [lessorRepTypes]="lessorRepType$ | async"
      [cabinetShelfRefs]="cabinetShelfRef$ | async"
      [rackTrayRefs]="rackTrayRef$ | async"
      [fileLocations]="fileLocation$ | async"
      [documentTypeCodes]="documentTypeCode$ | async"
      [documentTypes]="documentType$ | async"
      [securityClassifications]="securityClassification$ | async"
      [titles]="title$ | async"
      [banks]="bank$ | async"

      [ownershipTypes]="ownershipType$ | async"
      [addressBooks]="addressBook$ | async"
      [isLoadingAddressBook]="isLoadingAddressBook$ | async"
      [isLoadingDocument]="isLoadingDocument$ | async"
      [isLoadingLessorAreaMaker]="isLoadingLessorAreaMaker$ | async"
      [isLoadingLessorRepresentative]="isLoadingLessorRepresentative$ | async"
      [isLoadingLessorStakeholder]="isLoadingLessorStakeholder$ | async"
      [isLoadingIndividualAcreages]="isLoadingIndividualAcreages$ | async"
      [isLoadingAssetLocation]="isLoadingAssetLocation$ | async"
      [isLoadingLessorInfo]="isLoadingLessorInfo$ | async"
      [completed]="completed$ | async"
      [progress]="progress$ | async"
      [error]="error$ | async"
      [isInProgress]="isInProgress$ | async"
      [isReady]="isReady$ | async"
      [hasFailed]="hasFailed$ | async"
      (emitUpload)="uploadFile($event)"
      (emitSaveManyDoc)="onSaveManyDoc($event)"
      (emitCancel)="cancelUpload($event)"
      (emitTask)="onTask($event)"
      (emitReset)="resetUpload($event)"
      (emitLandTitle)="onSaveLandTitle($event)"
      (emitAddressBook)="onSearchAddressBook($event)"
      (emitSaveAddressBook)="onSaveAddressBook($event)"
      (emitSaveAddressBookLessor)="onSaveAddressBookLessor($event)"
      (emitLessorAreaMaker)="onEmitLessorAreaMaker($event)"
      (emitLessorAreaMakerDelete)="onEmitLessorAreaMakerDelete($event)"
      (emitLessorRepresentative)="onEmitLessorRepresentative($event)"
      (emitLessorStakeholder)="onEmitLessorStakeholder($event)"
      (emitLessorRepresentativeDelete)="onEmitLessorRepresentativeDelete($event)"
      (emitLessorStakeholderDelete)="onEmitLessorStakeholderDelete($event)"
      (emitIndividualAcreages)="onEmitIndividualAcreages($event)"
      (emitUpdateAddressLessorInfo)="onEmitUpdateAddressLessorInfo($event)"
      (emitIndividualAcreagesDelete)="onEmitIndividualAcreagesDelete($event)"
      (emitAssetLocation)="onEmitAssetLocation($event)"
      (emitAssetLocationDelete)="onEmitAssetLocationDelete($event)"
      (emitLessorInfoDelete)="onEmitLessorInfoDelete($event)"

      (emitClearAddressBook)="onEmitClearAddressBook($event)"
      *ngIf="
        !(loadingLandTitle) &&
        !(isLoadingAcquisitionType$ | async) &&
        !(isLoadingCurrency$ | async) &&
        !(isLoadingMeasure$ | async) &&
        !(isLoadingSubSubGroup$ | async) &&
        !(isLoadingGroup$ | async) &&
        !(isLoadingSubGroup$ | async) &&
        !(isLoadingCofOStatus$ | async) &&
        !(isLoadingCategory$ | async) &&
        !(isLoadingLandUseStatus$ | async) &&
        !(isLoadingDivestment$ | async) &&
        !(isLoadingRightHeld$ | async) &&
        !(isLoadingPurpose$ | async) &&
        !(isLoadingTerrain$ | async) &&
        !(isLoadingBankingStatus$ | async) &&
        !(isLoadingMeasuringFactor$ | async) &&
        !(isLoadingGeoDatum$ | async) &&
        !(isLoadingState$ | async) &&
        !(isLoadingLga$ | async) &&
        !(isLoadingCommunity$ | async) &&
        !(isLoadingDivision$ | async) &&
        !(isLoadingFileLocation$ | async) &&
        !(isLoadingRackTrayRef$ | async) &&
        !(isLoadingCabinetShelfRef$ | async) &&
        !(isLoadingDocumentType$ | async) &&
        !(isLoadingDocumentTypeCode$ | async) &&
        !(isLoadingSecurityClassification$ | async) &&
        !(isLoadingOwnershipType$ | async) &&
        !(isLoadingLessorRepType$ | async) &&
        !(isLoadingTitle$ | async) &&
        !(isLoadingBank$ | async) &&
        !(isLoadingAppConfig$ | async)
      "
      >

      </cradua-create-acquisition>
    </ng-container>
      <cradua-list-spinner
      *ngIf="
        (loadingLandTitle)||
        (isLoadingAcquisitionType$ | async) ||
        (isLoadingCurrency$ | async) ||
        (isLoadingMeasure$ | async) ||
        (isLoadingSubSubGroup$ | async) ||
        (isLoadingGroup$ | async) ||
        (isLoadingSubGroup$ | async) ||
        (isLoadingAppConfig$ | async) ||
        (isLoadingState$ | async) ||
        (isLoadingLga$ | async) ||
        (isLoadingCommunity$ | async) ||
        (isLoadingDivision$ | async) ||
        (isLoadingCofOStatus$ | async) ||
        (isLoadingFileLocation$ | async) ||
        (isLoadingRackTrayRef$ | async) ||
        (isLoadingCabinetShelfRef$ | async) ||
        (isLoadingDocumentType$ | async) ||
        (isLoadingDocumentTypeCode$ | async) ||
        (isLoadingTitle$ | async) ||
        (isLoadingBank$ | async) ||
        (isLoadingOwnershipType$ | async) ||
        (isLoadingLessorRepType$ | async) ||
        (isLoadingGeoDatum$ | async)
      "
    >
    </cradua-list-spinner>

    </ng-template>

  </div>


</main>




